module.exports = __webpack_public_path__ + "img/summary_asin.9125ea5.svg";